<template>
    <error-message
            v-bind:message="message"
            v-bind:field-name="fieldName"
    >
    </error-message>
</template>

<script>
    import ErrorMessage from './ErrorMessage.vue';
    import ResourceMixin from '../../Util/Mixins/resources'

    export default {
        name: "required-error-message",
        components: {
            ErrorMessage
        },
        mixins: [ResourceMixin],
        computed: {
            message(){
                const vm = this;

                //The field {0} is required, or
                //This field is required
                return vm.fieldName ? 
                    vm.resource('RequiredAttribute_ValidationError').replace('{0}', vm.fieldName) : 
                    vm.resource('RequiredAttribute_ValidationError_Generic');
                
                return ;
            }
        },
        props: {
            fieldName: {
                type: String,
                default: null
            }
        }
    }
</script>
